// extracted by mini-css-extract-plugin
export default {"container":"ARMHome_container__-Vo5N"};